import { css } from '@/styled-system/css';

export const feedContainer = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 'zIndexOverLoader',
  bg: 'hpxWhite',
  overflow: 'hidden',
  md: {
    position: 'relative',
    flexDirection: 'row',
    gap: '8px',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    zIndex: 'auto',
    bg: 'transparent',
    paddingX: '2x',
  },
});

export const feedHeader = css({
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  paddingX: '2x',
  paddingTop: 'calc(token(spacing.2x) + env(safe-area-inset-top))',
  paddingBottom: 'xs',
  md: {
    display: 'none',
  },
});

export const feedHeaderRow = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const backToListButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: 'hpxBlue600',
  fontSize: 'sm',
  padding: 0,
  _focus: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const backToListChevron = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  flexShrink: 0,
});

export const feedCounterText = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  textAlign: 'center',
  paddingTop: 'xs',
});

export const feedCounterBold = css({
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const feedScroller = css({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  overflowY: 'scroll',
  overscrollBehavior: 'contain',
  scrollSnapType: 'y mandatory',
  display: 'flex',
  flexDirection: 'column',
  scrollbarWidth: 'none',
  gap: 0,
  paddingBottom: 'env(safe-area-inset-bottom)',
  touchAction: 'pan-y',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  md: {
    height: '100%',
    gap: '1x',
    paddingBottom: 0,
  },
});

export const feedSlide = css({
  width: '100%',
  height: 'calc(100% - 16px)',
  flexShrink: 0,
  scrollSnapAlign: 'start',
  scrollSnapStop: 'always',
  overflow: 'hidden',
  md: {
    overflow: 'visible',
  },
});

export const rightRail = css({
  width: '48px',
  flexShrink: 0,
  display: 'none',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  paddingTop: '1x',
  paddingRight: '1x',
  position: 'sticky',
  top: 0,
  alignSelf: 'flex-start',
  md: {
    display: 'flex',
  },
});

export const navButton = css({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bg: 'hpxWhite',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  cursor: 'pointer',
  transitionProperty: 'background-color, border-color, opacity',
  transitionDuration: '0.15s',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  _hover: {
    bg: 'hpxGrey100',
    borderColor: 'hpxGrey500',
  },
  _disabled: {
    opacity: 0.3,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
});

export const navIcon = css({
  width: '18px',
  height: '18px',
  color: 'hpxBlue600',
});

export const srOnly = css({
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
});
